
import AsyncStorage from '@react-native-community/async-storage';
import * as ActionTypes from './../constants';
import { baseUrl } from './../actions';
import axios from 'axios';
import { getUserToken } from './getUserToken';



const dispatchRequestAdsInfo = () => ({
    type: ActionTypes.REQUEST_ADS_INFO,
    
})

const dispatchReceivedAdsInfo = res => ({
    type: ActionTypes.RECEIVED_ADS_INFO,
    res
})

const dispatchErrorAdsInfo = err => ({
    type: ActionTypes.ERROR_ADS_INFO,
    err
})

const dispatchClearAdsInfo = () => ({
    type: ActionTypes.CLEAR_ADS_INFO
})

export const clearAdsInfo = () => dispatchClearAdsInfo();

export const adsInfo = () => dispatch => {

    dispatch(dispatchRequestAdsInfo());

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'post',
                url: `${baseUrl}/api/allads`,
                // data: adsInfo,
                headers: {
                    'Authorization': `Bearer ${authKey}`
                }
            }
            return axios(options)
                .then(async ({data}) => {
                    const ads = data && data.status && data.status.ads;            
                    if(ads) {
                        await AsyncStorage.setItem('adsInfo', JSON.stringify(ads));
                    }
                    dispatch(dispatchReceivedAdsInfo(data))
                })
        })
        .catch(e => dispatch(dispatchErrorAdsInfo(e)));    
}